import { axiosFactory, errorHandler, currentPage } from "@/configs/axios";

const driverReminder = {
  api: () => {
    return axiosFactory()
      .auth.get(`reminders/drivers/${currentPage()}`)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

const servicesReminder = {
  api: () => {
    return axiosFactory()
      .auth.get(`reminders/company-vehicle-services/${currentPage()}`)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

const vehiclesReminder = {
  api: () => {
    return axiosFactory()
      .auth.get(`reminders/comapny-vehicles/${currentPage()}`)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export { driverReminder, servicesReminder, vehiclesReminder };
